import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { GrantsPage } from "@/features/operator/GrantsPage";

export const Route = createFileRoute("/app/operator/grants")({
  validateSearch: z.object({
    view: z.enum(["grants", "denies"]).optional().catch(undefined),
    tenant: z.string().optional(),
  }),
  component: GrantsPage,
});
